import React from 'react'
import { Provider } from 'react-redux'
import { store, history } from './redux/store'
import { ThemeProvider } from '@mui/styles'
import { SnackBarProvider } from './context/snackbarContext'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './App.css'
import theme from './themes'
import InitRoutes from './router'

import { queryClient } from './utils/query-client-provider'

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <SnackBarProvider>
          <InitRoutes history={history} />
        </SnackBarProvider>
      </Provider>
    </ThemeProvider>
  </QueryClientProvider>
)
export default App
